var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var EmailIcon = function (props) {
    return (_jsxs("svg", __assign({ width: '48', height: '48', viewBox: '0 0 48 48', xmlns: 'http://www.w3.org/2000/svg' }, props, { children: [_jsx("circle", { cx: '24', cy: '24', r: '24', fill: '#F79432' }), _jsx("path", { fill: '#FFF', d: 'M15 18c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H17c-1.1 0-2-.9-2-2V18zm2 .8V30h14V18.8l-7 5.6-7-5.6zm0-1.6l7 5.6 7-5.6H17z' })] })));
};
